/**
 * ========================================
 * 🔇 LOGGER CONDICIONAL
 * ========================================
 * 
 * Logs aparecem apenas em desenvolvimento.
 * Em produção, todos os logs são silenciados.
 */

const isDev = import.meta.env.DEV;

export const logger = {
  log: (...args) => isDev && console.log(...args),
  warn: (...args) => isDev && console.warn(...args),
  error: (...args) => isDev && console.error(...args),
  info: (...args) => isDev && console.info(...args),
  debug: (...args) => isDev && console.debug(...args),
};

// Aliases para facilitar migração
export const devLog = (...args) => isDev && console.log(...args);
export const devWarn = (...args) => isDev && console.warn(...args);
export const devError = (...args) => isDev && console.error(...args);

export default logger;
